import axios from 'axios'
import { config } from '../Config/config'

const walletService = {
    getAll : (id) =>{
        const result = axios.get(config.apiUrl + '/wallet/' + id)
        .then(respon => {
            return {
                success : respon.data.success,
                result: respon.data.result[0]
            }
        })
        .catch(error =>{
            return {
                success:false,
                error:error
            }
        })
        return result
    },
    aktifWallet : (body) =>{
        const result = axios.put(config.apiUrl + '/wallet/activated/',body)
        .then(respon => {
            return {
                success : respon.data.success,
                result: respon.data.result
            }
        })
        .catch(error =>{
            return {
                success:false,
                error:error
            }
        })
        return result
    },
    getNominal : (id) =>{
        const result = axios.get(config.apiUrl + '/nominal/' + id)
        .then(respon => {
            return {
                success : respon.data.success,
                result: respon.data.result
            }
        })
        .catch(error =>{
            return {
                success:false,
                error:error
            }
        })
        return result
    },
    updWallet :(body) => {
        const result = axios.put(config.apiUrl + '/wallet/upd/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    insCustNom:(body) => {
        console.log(body)
        const result = axios.post(config.apiUrl + '/wallet/insNom/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    instTopUp:(body) => {
        console.log(body)
        const result = axios.post(config.apiUrl + '/wallet/insTopUp/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    insertWallet:(body) => {
        const result = axios.post(config.apiUrl + '/insertwallet', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getDefault : (nominal) => {
        const result = axios.get(config.apiUrl + '/default_nominal/'+nominal)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    getCustomNom:(body) => {
        const result = axios.post(config.apiUrl + '/nominalcustom', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    countWrong : (body) =>{
        const result = axios.put(config.apiUrl + '/update_wrongpin',body)
        .then(respon => {
            return {
                success : respon.data.success,
                result: respon.data.result
            }
        })
        .catch(error =>{
            return {
                success:false,
                error:error
            }
        })
        return result
    },
    resetWrong : (body) =>{
        const result = axios.put(config.apiUrl + '/reset_wrongpin',body)
        .then(respon => {
            return {
                success : respon.data.success,
                result: respon.data.result
            }
        })
        .catch(error =>{
            return {
                success:false,
                error:error
            }
        })
        return result
    },
    withDraw:(body) => {
        // console.log(body)
        const result = axios.post(config.apiUrl + '/withdraw', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getDefaultNom: () => {
        const result = axios.get(config.apiUrl + '/default_nom/')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    }

}
export default walletService 